import { z } from 'zod'

/**
 * Kept as a raw record (not wrapped in `z.object`) so it can be passed
 * to `createEnv` while still being wrappable with `z.object` in the CI
 * validation test.
 */
export const envSchema = {
  VITE_ENV: z.enum(['dev', 'staging', 'prod']),
  VITE_API_URL: z.url(),

  // Auth0
  VITE_AUTH0_DOMAIN: z.string().min(1),
  VITE_AUTH0_CLIENT_ID: z.string().min(1),
  VITE_AUTH0_ORGANIZATION_ID: z.string().min(1),
  VITE_AUTH0_API_AUDIENCE: z.string().min(1),

  // Connect
  VITE_CONNECT_URL: z.url(),

  // Feature flags
  VITE_FLAGS_PRIMARY_PROVIDER: z.enum(['launchDarkly', 'local']),
  VITE_FLAGS_LAUNCH_DARKLY_CLIENT_SIDE_ID: z.string(),

  // App-specific
  VITE_TEXTING_SUBTASKS_UNKNOWN_NUMBER_PATIENT_ID: z.string(),

  // Datadog
  VITE_DATADOG_ENABLED: z
    .enum(['true', 'false'])
    .transform((v) => v === 'true'),
  VITE_DATADOG_APPLICATION_ID: z.string(),
  VITE_DATADOG_CLIENT_TOKEN: z.string(),
  VITE_DATADOG_SERVICE: z.string().min(1),
  VITE_DATADOG_SITE: z.string().min(1),
  VITE_DATADOG_ENV: z.string().min(1),

  // Amazon Connect
  VITE_AMAZON_CCP_THYMECARE_INSTANCE_URL: z.url(),
  VITE_AMAZON_CCP_INSTANCE_REGION: z.string().min(1),
  VITE_AMAZON_CCP_THYMECARE_LOGIN_URL: z.url(),

  // Strapi
  VITE_STRAPI_API_URL: z.url(),
  VITE_STRAPI_API_KEY: z.string().min(1),

  // MeiliSearch
  VITE_MEILI_SEARCH_URL: z.url(),
  VITE_MEILI_SEARCH_API_KEY: z.string().min(1),

  // Event service
  VITE_EVENT_SERVICE_URL: z.url(),
  VITE_EVENT_SERVICE_API_KEY: z.string().min(1),
}
